import { OnInit, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  selector: "app-user-full-details",
  templateUrl: "./user-full-details.component.html",
  styleUrls: ["./user-full-details.component.scss"],
})
export class UserFullDetailsComponent implements OnInit {
  userId: number;
  role: string;
  showUserHistory: boolean = false;
  showOrders: boolean = false;
  showNotes: boolean = false;
  showTransaction: boolean = false;
  showContracts: boolean = false;
  showCommission: boolean = false;
  showUserDetails: boolean = false;
  showArrangerDetails: boolean = false;
  showPrepaids: boolean = false;
  showContractSignDate: boolean = false;
  showNewsletter: boolean = false;

  constructor(private route: ActivatedRoute, public location: Location) {
    this.route.params.subscribe((params) => {
      this.userId = params["id"];
      this.role = params["role"];
    });
  }

  ngOnInit(): void {}

  public onShowUserHistory(): void {
    this.showUserHistory = true;
  }

  public onShowPrepaids() {
    this.showPrepaids = true;
  }

  public onShowUserOrders(): void {
    this.showOrders = true;
  }

  public onShowNotes(): void {
    this.showNotes = true;
  }

  public onShowTransaction(): void {
    this.showTransaction = true;
  }

  public onShowContracts(): void {
    this.showContracts = true;
  }

  public onShowCommission(): void {
    this.showCommission = true;
  }

  public onShowUserDetails(): void {
    this.showUserDetails = true;
  }

  public onShowArrangerDetails(): void {
    this.showArrangerDetails = true;
  }

  public onShowNewsletter(): void {
    this.showNewsletter = true;
  }
}
